<template>
  <div class="page activity-list">
    <div class="container">
      <div class="category-filter" v-show="!isMobile">
        <div class="filter-category">
          <div class="filter-title">活动分类：</div>
          <div class="filter-content">
            <div class="item" :class="{ 'item item-active': queryParams.category_id === '' }"
              @click.stop="changeSort('')">全部</div>
            <div class="item" v-for="(item, index) in sortList" :key="index" :class="{
              'item-active': queryParams.category_id === item.id,
            }" @click.stop="changeSort(item.id)">{{ item.name }}</div>
          </div>
        </div>
        <div class="filter-category">
          <div class="filter-title">活动状态：</div>
          <div class="filter-content">
            <div class="item" :class="{ 'item item-active': queryParams.status === '' }" @click.stop="statusChange('')">
              全部</div>
            <div class="item" v-for="(item, index) in activeStateList" :key="index" :class="{
              'item-active': queryParams.status === item.id,
            }" @click.stop="statusChange(item.id)">{{ item.name }}</div>
          </div>
        </div>
        <div class="filter-category">
          <div class="filter-title">活动标签：</div>
          <div class="filter-content">
            <div class="item" :class="{ 'item item-active': queryParams.tag_id === '' }" @click.stop="changeTag('')">全部
            </div>
            <div class="item" v-for="(item, index) in tagList" :key="index" :class="{
              'item-active': queryParams.tag_id === item.id,
            }" @click.stop="changeTag(item.id)">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="mobile-filter" v-show="isMobile">
        <div class="mobile-filter-row">
          <el-select v-model="queryParams.category_id" placeholder="活动分类" @change="onMobileFilterChange"
            class="mobile-select" popper-class="mobile-filter-popper">
            <el-option label="全部分类" value=""></el-option>
            <el-option v-for="item in sortList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="queryParams.status" placeholder="活动状态" @change="onMobileFilterChange"
            class="mobile-select" popper-class="mobile-filter-popper">
            <el-option label="全部状态" value=""></el-option>
            <el-option v-for="item in activeStateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="queryParams.tag_id" placeholder="活动标签" @change="onMobileFilterChange"
            class="mobile-select" popper-class="mobile-filter-popper">
            <el-option label="全部标签" value=""></el-option>
            <el-option v-for="item in tagList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="showcase" :class="!listData.length ? 'showcase-empty' : ''">
        <template v-if="listData.length">
          <div class="goods-list">
            <div class="goods-item" v-for="(item, index) in listData" :key="index" @click="toDetail(item)">
              <div class="goods-item-img">
                <div class="goods-img">
                  <el-image class="image" :src="item.cover" @error="handleError" />
                </div>
              </div>
              <div class="goods-item-info">
                <div class="title">
                  <span class="txt ellipsis">{{ item.title }}</span>
                  <span class="category_name ellipsis">{{ item.category_name }}</span>
                </div>
                <div class="time ellipsis">
                  <span class="tit">活动时间：</span>
                  <span class="txt">{{ item.start_time | dateFormat }} / {{ item.end_time | dateFormat }}</span>
                </div>
                <div class="tags ellipsis">
                  <el-tag class="tag" size="small" v-for="(ele, inx) in item.tag_list" :key="inx">{{ ele.name
                  }}</el-tag>
                </div>
              </div>
            </div>
          </div>
          <div class="elpagination">
            <div class="elpagination-title">共{{ total }}条</div>
            <el-pagination background layout="prev, pager, next, jumper" prev-text="上一页" next-text="下一页" :total="total"
              :current-page="queryParams.page" :page-size="queryParams.per_page"
              @current-change="pageChange"></el-pagination>
          </div>
        </template>
        <template v-else>
          <el-empty :image-size="110" class="el-empty--cont"></el-empty>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivityList } from "@/api/activity"
import { getCategoryList, getTagList } from "@/api/common"
import dayjs from "dayjs"
export default {
  name: "ActivityList",
  components: {},
  filters: {
    dateFormat(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY.MM.DD HH:mm:ss")
    },
  },
  data() {
    return {
      listData: [],
      sortList: [],
      queryParams: {
        keyword: "",
        status: "",
        category_id: "",
        tag_id: "",
        per_page: 20,
        page: 1,
      },
      total: 0,
      activeStateList: [
        {
          id: 'no_start',
          name: '未开始'
        },
        {
          id: 'on_going',
          name: '进行中'
        },
        {
          id: 'on_end',
          name: '已结束'
        }
      ],
      tagList: [],
      defaultImg: require("@/assets/default/image02.jpg"),
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 640
    }
  },
  created() {
    this.initCategory()
    this.initTag()
  },
  mounted() {
    this.getList()
  },
  methods: {
    initCategory() {
      getCategoryList().then((res) => {
        if (res.code === 0) {
          this.sortList = res.data?.data ?? []
        }
      }).catch(() => { })
    },
    initTag() {
      getTagList().then((res) => {
        if (res.code === 0) {
          this.tagList = res.data?.data ?? []
        }
      }).catch(() => { })
    },
    // 获取列表数据
    getList() {
      getActivityList(this.queryParams).then((res) => {
        if (res.code === 0) {
          this.listData = res.data?.data ?? []
          this.total = res.data?.total ?? 0
        }
      }).catch(() => { })
    },
    handleError(e) {
      // 当图片加载失败时，将图片地址设置为默认图片
      e.target.src = this.defaultImg
      // 可以添加额外的处理，比如提示用户或者进行日志记录
    },
    changeSort(id) {
      this.queryParams.category_id = id
      this.queryParams.page = 1
      this.getList()
    },
    statusChange(id) {
      this.queryParams.status = id
      this.queryParams.page = 1
      this.getList()
    },
    changeTag(id) {
      this.queryParams.tag_id = id
      this.queryParams.page = 1
      this.getList()
    },
    onMobileFilterChange() {
      this.queryParams.page = 1
      this.getList()
    },
    //页码发生改变时
    pageChange(val) {
      this.queryParams.page = val
      this.getList()
    },
    toDetail(item) {
      if (item.introduce_type && Number(item.introduce_type) === 1) {
        window.open(item.introduce_link, "_blank")
      } else {
        window.localStorage.setItem("menuId", 1)
        this.$store.dispatch("setmenuid", 1)
        this.$router.push({
          path: "/home/activity/detail",
          query: {
            id: item.id,
          },
        })
      }
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  width: 100%;
  max-width: 1800px;
  margin: 0 auto 40px;
  overflow: hidden;

  .container {
    margin-top: 30px;

    .category-filter {
      min-height: 60px;
      padding: 20px 30px;
      background: #fff;
      border-radius: 5px;
      // display: flex;
      // flex-wrap: wrap;

      .filter-category {
        display: flex;
        align-items: flex-start;
        margin-right: 40px;
        margin-bottom: 10px;

        &:last-child {
          margin-right: 0;
        }

        .filter-title {
          flex-basis: 70px;
          color: #333;
          font-size: 14px;
          line-height: 30px;
          font-weight: 400;
          user-select: none;
          white-space: nowrap;
        }

        .filter-content {
          flex-grow: 1;
          flex-shrink: 1;
          margin-left: 10px;

          .item {
            display: inline-block;
            color: #333;
            font-size: 14px;
            font-weight: 400;
            margin-bottom: 10px;
            margin-right: 15px;
            user-select: none;
            white-space: nowrap;
            cursor: pointer;
            padding: 0 12px;
          }

          .item-active {
            color: #005cbb;
            height: 30px;
            line-height: 30px;
            background: #e5eef8;
            border-radius: 15px;
            text-align: center;
          }
        }
      }
    }

    .showcase {
      .goods-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .goods-item {
          width: calc((100% - 80px) / 5);
          height: 360px;
          background-color: #fff;
          // box-shadow: 0px 0px 29px 0px rgb(0 80 179 / 8%);
          border-radius: 5px;
          overflow: hidden;
          flex-shrink: 1;
          // cursor: pointer;
          margin: 30px 0px 0px 20px;

          // &:hover {
          //   border: 1px solid rgb(9, 235, 178);
          // }
          .goods-item-img {
            position: relative;
            height: calc(100% - 124px);
            overflow: hidden;
            cursor: pointer;

            .goods-img {
              width: 100%;
              height: 100%;
              background: aliceblue;

              .image {
                display: inline-block;
                -webkit-transition-duration: 0.3s;
                transition-duration: 0.3s;
                -webkit-transition-property: transform;
                transition-property: transform;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                box-shadow: 0 0 1px rgba(0, 0, 0, 0);
              }

              .image:hover,
              .image:focus,
              .image:active {
                -webkit-transform: scale(1.1);
                transform: scale(1.1);
              }

              .image {
                width: 100%;
                height: 100%;
              }
            }

            .default-img {
              width: 100%;
              height: 235px;
              // background: #daebfc;
              text-align: center;
              background: aliceblue;

              .image {
                display: inline-block;
                -webkit-transition-duration: 0.3s;
                transition-duration: 0.3s;
                -webkit-transition-property: transform;
                transition-property: transform;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                box-shadow: 0 0 1px rgba(0, 0, 0, 0);
              }

              .image:hover,
              .image:focus,
              .image:active {
                -webkit-transform: scale(1.1);
                transform: scale(1.1);
              }

              .image {
                width: 100%;
                height: 100%;
              }
            }
          }

          .goods-item-info {
            height: 124px;
            padding: 15px 10px;
            background: #ffffff;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .title {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .txt {
                display: inline-block;
                flex: 1;
                color: #000;
                font-size: 16px;
                font-weight: 500;
                padding-right: 8px;
              }

              .category_name {
                display: inline-block;
                width: 80px;
                padding: 6px 10px;
                border-radius: 5px;
                background-color: #005cbb;
                color: #fff;
                font-size: 12px;
                box-sizing: border-box;
                text-align: center;
              }
            }

            .time {
              height: 20px;
              line-height: 20px;
            }

            .tit,
            .txt {
              color: #999;
              font-size: 12px;
              font-weight: 400;
              // border-radius: 12px;
            }

            .tags {
              .tag {
                height: 24px;
                border-radius: 24px;
                margin-right: 3px;
              }
            }
          }
        }

        .goods-item:nth-child(5n + 1) {
          margin-left: 0px;
        }

        .goods-item:nth-child(n + 6) {
          margin-top: 20px;
        }
      }

      .elpagination {
        margin-top: 30px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .elpagination-title {
          margin-right: 10px;
        }
      }

      .el-empty--cont {
        padding: 0px;
        min-height: 400px;
      }
    }

    .showcase-empty {
      background-color: #fff;
      border-radius: 5px;
      margin-top: 30px;
      overflow: hidden;
    }
  }
}

@media screen and (max-width: 640px) {
  .page {
    padding: 0 10px;
    box-sizing: border-box;

    .container {
      margin-top: 15px;

      .mobile-filter {
        padding: 15px 10px;
        background: #fff;
        border-radius: 5px;
        margin-bottom: 15px;

        .mobile-filter-row {
          display: flex;
          gap: 8px;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;

          &::-webkit-scrollbar {
            display: none;
          }
        }

        .mobile-select {
          width: 125px;
          flex-shrink: 0;

          ::v-deep .el-input__inner {
            height: 30px;
            line-height: 30px;
            background: #e5eef8;
            border: none;
            border-radius: 15px;
            color: #005cbb;
            font-size: 14px;
            padding: 0 15px;
            text-align: center;
          }

          ::v-deep .el-select__caret {
            color: #005cbb;
            line-height: 30px;
          }

          ::v-deep .el-input.is-focus .el-input__inner {
            background: #005cbb;
            color: #fff;
          }
        }
      }

      .showcase {
        .goods-list {
          .goods-item {
            width: calc((100% - 10px) / 2);
            height: auto;
            margin: 10px 0 0 10px;

            .goods-item-img {
              height: 140px;
            }

            .goods-item-info {
              height: auto;
              padding: 10px;

              .title {
                .txt {
                  font-size: 14px;
                }

                .category_name {
                  width: auto;
                  padding: 4px 8px;
                  font-size: 10px;
                }
              }
            }
          }

          .goods-item:nth-child(2n + 1) {
            margin-left: 0;
          }

          .goods-item:nth-child(n + 3) {
            margin-top: 10px;
          }
        }

        .elpagination {
          justify-content: center;
        }
      }
    }


  }


}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .page {
    .container {
      .showcase {
        .goods-list {
          .goods-item {
            width: calc((100% - 60px) / 4);
            height: 320px;
          }

          .goods-item:nth-child(4n + 1) {
            margin-left: 0;
          }

          .goods-item:nth-child(5n + 1) {
            margin-left: 20px;
          }
        }
      }
    }
  }
}
</style>